import { useContext } from "react";
import { GlobalContext } from "../GlobalContext";

function useAnalyticsDispatch(eventName: string, dispatch: (action: any) => void) {
  const { analytics } = useContext(GlobalContext);

  return (action: any) => {
    analytics.trackEvent(eventName, action);
    dispatch(action);
  };
}

export default useAnalyticsDispatch;
